import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { environment } from 'environments/environment';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class SearchService {
	private getConfigURL = environment.BASE_URL + "/config.json";
	private config = null;

	constructor(private http: Http) {
	}

	getConfigurationFromUrl(): Promise<Object> {
		return this.http.get(this.getConfigURL)
			.toPromise()
			.then(response => {
				this.config = response.json();
				if (response.json())
					return this.config;
				else
					return {}
			})
			.catch(this.handleError);
	}

	getConfigurationSaved(): Object {
		return this.config;
	}

	private handleError(error: any): Promise<any> {
		console.error('An error occurred', error); // for demo purposes only
		return Promise.reject(error.message || error);
	}
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/services/search/search.service.ts